import React from 'react';
import { useDispatch } from 'react-redux';
import { hideModal } from 'cards/actions/modalActions';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import cx from 'classnames';
import Megaphone from 'assets/images/invitations/megaphone.svg';

import { CARD_TYPES } from '../../../../constants/CardTypes';
import styles from './ProofModal.module.less';

const ModalBodyText = {
  [CARD_TYPES.place]:
    'Any guest names and tables you assigned will be saved, we’ll just hold off on printing them until you’re ready to place a full order. For now, you’ll receive a single card with placeholder text.',
  [CARD_TYPES.thankyou]:
    "Any messages you wrote for the inside of your cards will be permanently deleted. Assigned guest addressing will also be removed. We can help you address your envelopes when you're ready to place a full order.",
  generic:
    "Assigned guest addressing will also be removed. We can help you address your envelopes when you're ready to place a full order.",
};

interface ModalProps {
  cardType: string;
  onConfirmAction: () => Promise<void>;
}

export const ProofDecreaseConfirmModal: React.FC<ModalProps> = ({ cardType, onConfirmAction }) => {
  const dispatch = useDispatch();
  const handleCloseAction = () => dispatch(hideModal());
  const handleConfirmAction = () => onConfirmAction().then(() => handleCloseAction());

  return (
    <div>
      <div className="modal-header">
        <img src={Megaphone} alt="Customizing a proof" className={styles.svg} />
        <h2 className={cx('modal-title', styles.title)}>
          Are you sure you want a printed proof instead?
        </h2>
      </div>
      <div className="modal-body">
        <p className={cx('text-left', styles.text)}>
          {ModalBodyText[cardType] || ModalBodyText.generic}
        </p>
      </div>
      <div className="modal-footer">
        <div className="text-group row">
          <ButtonV2 onClick={handleCloseAction} variant="secondary">
            Cancel
          </ButtonV2>
          <ButtonV2 onClick={handleConfirmAction} variant="danger">
            Yes, Change to Proof
          </ButtonV2>
        </div>
      </div>
    </div>
  );
};

export default ProofDecreaseConfirmModal;
